export default "__VITE_ASSET__ab483255__"